module.exports = __webpack_public_path__ + "static/media/arrow-65.cea5e582.svg";